var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "calculation-toggle",
    "class": {
      active: _vm.value,
      busy: _vm.busy
    },
    attrs: {
      "type": "button",
      "role": "switch",
      "aria-checked": _vm.value ? 'true' : 'false',
      "aria-label": _vm.value ? 'Vyradiť z výpočtu' : 'Zahrnúť do výpočtu',
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('change', !_vm.value);
      }
    }
  }, [_c('span', {
    staticClass: "calculation-toggle-copy"
  }, [_c('span', {
    staticClass: "calculation-toggle-label"
  }, [_vm._v(" " + _vm._s(_vm.value ? "Vo výpočte" : "Mimo výpočtu") + " ")]), _c('span', {
    staticClass: "calculation-toggle-note"
  }, [_vm._v(" " + _vm._s(_vm.value ? "Započítava sa do limitov" : "Položka zostáva iba evidovaná") + " ")])]), _vm._m(0)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "calculation-toggle-track",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "calculation-toggle-knob"
  })]);

}]

export { render, staticRenderFns }